import Vue from 'vue';
import IdxShow from './_components/IdxShow.vue';

Vue.prototype.$hcaptchaSitekey = process.env.MIX_HCAPTCHA_SITEKEY;

(function() {
    new Vue({
        components: {
            IdxShow,
        },
        el: '#idxShow',
        template: '<IdxShow />',
    });
})();
